import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '../../../models/language.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { LanguageService } from '../../../services/language/language.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css'],
  providers: []
})
export class LanguageComponent implements OnInit {

  selectedLanguage: Language = null;
  languageListTitles: DataTableField[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {};
  paginationType = KontableComponent.ServerPagination;

  constructor(
    public srvLanguage: LanguageService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) {
    this.translate.get(['languageList']).subscribe((res) => {
      this.languageListTitles = [
        { id: 'id', label: '#' },
        { id: 'iso_code', label: res.languageList.isoCode },
        { id: 'language', label: res.languageList.language },
        { id: 'nls_code', label: res.languageList.nlsCode },
      ];
    });
  }

  ngOnInit() {

    this.translate.get([
      'languageList.add_title',
      'languageList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['languageList.add_title'];
      this.labels['edit_title'] = res['languageList.edit_title'];
    });

    //this.srvLanguage.getAll().subscribe();
  }

  refresh () {
    /*
    this.srvLanguage.getAll().subscribe( () => {
      this.newDataAvailable = true;
    });
    */
   this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvLanguage.languageEditing = data == null ? new Language() : data;
  }

  delete (record): void {
    this.srvLanguage.delete(record).subscribe(() => {
      this.refresh ();
    });
  }

  recover (record): void {
    this.srvLanguage.recover(record).subscribe(() => {
      this.refresh ();
    });
  }

  languageAdded($event): void {
    this.srvLanguage.post($event).subscribe(() => {
      this.srvDataTable.get('dt_language').showDetail = false;
      this.srvLanguage.languageEditing = null;
      this.refresh ();
    });

  }

  languageUpdated($event): void {
    this.srvLanguage.put($event).subscribe(() => {
        this.srvDataTable.get('dt_language').showDetail = false;
        this.srvLanguage.languageEditing = null;
      this.refresh ();
      }
    )
  }

  onDialogHide () {
    this.modalTitle = '';
    this.srvLanguage.languageEditing = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/language/language.component.ts